import React from 'react';
import { TOUR_DONE_MODAL } from '../../../../../components/modal/TourDoneModal';
import { showModal } from '../../../../../redux/actions';
import text from '../../../../../text';
import { store } from '../../../../../utilities/store';
import { StepContent, Steps } from './TourContent';
import { hightlightedAreaStyling, popoverCustomDefaultStyling } from './config';

const isOverflown = (element: HTMLElement | null) => {
  if (!element) return false;
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
};

export const TOUR_2D_MAP: Steps[] = [
  {
    selector: '.new-mp-search-wrapper',
    content: (): React.ReactNode => (
      <StepContent
        title={text('tour2dStep1Title')}
        description={text('tour2dStep1')}
      />
    ),
    position: 'right',
    padding: { mask: [10, 10, 130, 10] },
    styles: {
      popover: (base) => ({
        ...popoverCustomDefaultStyling(base),
        marginTop: '8px',
        marginLeft: '16px',
      }),
      highlightedArea: (base, state) => hightlightedAreaStyling(base, state),
    },
    customProps: {
      caret: 'left',
      hideNext: true,
      caretPosY: 'sm',
    },
  },
  {
    selector: '.shape-tools',
    content: () => (
      <StepContent
        title={text('tour2dStep2Title')}
        description={text('tour2dStep2')}
      />
    ),
    position: 'right',
    padding: { mask: [3, 17, 3, 10] },
    styles: {
      popover: (base) => ({
        ...popoverCustomDefaultStyling(base),
        marginLeft: '20px',
      }),
      highlightedArea: (base, state) => hightlightedAreaStyling(base, state),
    },
    customProps: {
      caret: 'left',
      hidePrev: true,
    },
  },
  {
    selector: '.product-controls-wrapper',
    content: () => (
      <StepContent
        title={text('tour2dStep3Title')}
        description={text('tour2dStep3')}
      />
    ),
    position: 'left',
    padding: { mask: [3, 25, 3, 15] },
    styles: {
      popover: (base) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { top, ...rest } = popoverCustomDefaultStyling(base);
        const _isOverFlown = isOverflown(
          document.querySelector('.ProductControlsMp')
        );
        const marginLeft = _isOverFlown ? '106px' : '98px';
        const productControlsElement =
          document.querySelector('.ProductControlsMp');
        const clientTop =
          productControlsElement?.getBoundingClientRect().top ?? 0;

        return {
          ...rest,
          marginLeft,
          top: `${clientTop - 154}px`,
        };
      },
      highlightedArea: (base, state) => hightlightedAreaStyling(base, state),
    },
    customProps: {
      caret: 'left',
    },
  },
  {
    selector: '.wrapper',
    content: () => (
      <StepContent
        title={text('tour2dStep4Title')}
        description={text('tour2dStep4')}
      />
    ),
    position: 'left',
    styles: {
      popover: (base) => ({
        ...popoverCustomDefaultStyling(base),
        marginLeft: '-20px',
      }),
      highlightedArea: (base, state) => hightlightedAreaStyling(base, state),
    },
    customProps: {
      caret: 'right',
      caretPosY: 'sm',
    },
  },
  {
    selector: '.RightMenuV2',
    content: () => (
      <StepContent title={text('tour2dStep5Title')} description=''>
        <p className='mb-3'>{text('tour2dStep5_1')}</p>
        <p className='mb-3'>{text('tour2dStep5_2')}</p>
        <p className='mb-0'>{text('tour2dStep5_3')}</p>
      </StepContent>
    ),
    position: 'left',
    styles: {
      popover: (base) => ({
        ...popoverCustomDefaultStyling(base),
        marginLeft: '-20px',
        maxWidth: '30%',
        top: `-30%`,
      }),
      highlightedArea: (base, state) => hightlightedAreaStyling(base, state),
    },
    customProps: {
      caret: 'right',
      callback: {
        next: () => {
          store.dispatch(showModal(TOUR_DONE_MODAL));
        },
      },
    },
  },
];
